module.exports = __webpack_public_path__ + "img/171_G_1527823077431.e5a78328.jpg";